import React from "react";
import TeamService from "services/TeamService";
import Button from "components/CustomButton";
import Loader from "components/Loader";
import * as timelineActions from "reteamStore/actions";
import { useDispatch } from "react-redux";

export default ({ post, setLoading, loading, post_types, setDialogState }) => {
  const dispatch = useDispatch();

  const publishPost = async () => {
    try {
      setLoading(true);

      post.type === "teamvideo"
        ? await TeamService.publishTeamVideo(post.data.id, post.team_id)
        : await TeamService.publishSlideShow(post.data.id, post.team_id);

      const postCopy = { ...post.data };
      postCopy.post_id = post?.id;

      postCopy.published = true;

      postCopy.is_responded = true;

      postCopy.published_at = new Date();
      dispatch(timelineActions.publishPost(postCopy));
      setDialogState(false);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  return (
    <span>
      <Button
        disabled={loading && true}
        buttonClass=" small-reject-btn "
        onClick={publishPost}
      >
        {!loading ? (
          `Publish ${post_types[post?.type] === "TeamVideo" ? "Team Video": post_types[post?.type]}`
        ) : (
          <Loader width={20} height={20} />
        )}
      </Button>
    </span>
  );
};
